import { useRef } from 'react';
import { postActivityLog } from 'services/generalServices';

export function useActivityLogPreview() {
  // prevent duplicate activity logs in the same mount
  const activitySentRef = useRef(new Set());

  const getKey = (data) => `${data?.pk || ''}|${data?.sk || ''}|${data?.event_key || ''}|${data?.event_subtype || ''}`;

  const addActivity = (data) => {
    const key = getKey(data);
    if (activitySentRef.current.has(key)) {
      return Promise.resolve();
    }
    activitySentRef.current.add(key);
    return postActivityLog(data)
      .then((response) => {
        // optional: keep key to block re-sends during this view
        return response;
      })
      .catch((error) => {
        // allow retry on error
        activitySentRef.current.delete(key);
        console.error('Error posting activity log:', error);
      });
  };

  return { addActivity };
}
